// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface IDocumentQrCodeDto
 */
export interface IDocumentQrCodeDto {
    /**
     * 
     * @type {string}
     * @memberof IDocumentQrCodeDto
     */
    qr_id: string;
    /**
     * 
     * @type {number}
     * @memberof IDocumentQrCodeDto
     */
    employee_id: number;
    /**
     * 
     * @type {number}
     * @memberof IDocumentQrCodeDto
     */
    organization_id: number;
    /**
     * 
     * @type {string}
     * @memberof IDocumentQrCodeDto
     */
    organization_path: string;
}

/**
 * Check if a given object implements the IDocumentQrCodeDto interface.
 */
export function instanceOfIDocumentQrCodeDto(value: object): value is IDocumentQrCodeDto {
    if (!('qr_id' in value) || value['qr_id'] === undefined) return false;
    if (!('employee_id' in value) || value['employee_id'] === undefined) return false;
    if (!('organization_id' in value) || value['organization_id'] === undefined) return false;
    if (!('organization_path' in value) || value['organization_path'] === undefined) return false;
    return true;
}

export function IDocumentQrCodeDtoFromJSON(json: any): IDocumentQrCodeDto {
    return IDocumentQrCodeDtoFromJSONTyped(json, false);
}

export function IDocumentQrCodeDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): IDocumentQrCodeDto {
    if (json == null) {
        return json;
    }
    return {
        
        'qr_id': json['qr_id'],
        'employee_id': json['employee_id'],
        'organization_id': json['organization_id'],
        'organization_path': json['organization_path'],
    };
}

export function IDocumentQrCodeDtoToJSON(json: any): IDocumentQrCodeDto {
    return IDocumentQrCodeDtoToJSONTyped(json, false);
}

export function IDocumentQrCodeDtoToJSONTyped(value?: IDocumentQrCodeDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'qr_id': value['qr_id'],
        'employee_id': value['employee_id'],
        'organization_id': value['organization_id'],
        'organization_path': value['organization_path'],
    };
}

